import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-ecart',
  templateUrl: './ecart.component.html',
  styleUrls: ['./ecart.component.scss']
})
export class EcartComponent implements OnInit {

  constructor(public generalService: GeneralService,) { }
  
list

  ngOnInit(): void {
    this.generalService.rechercheTable2('API_SourceEcart').subscribe((res:any)=>{
      this.list=res
      console.log(res);})
  }

  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
    this.openTest=false
  }

  clicked=false
  clickTShowCard(){
    this.clicked=true
  }
  clickToHideCard(){
    this.clicked=false
  }

  openTest=false
  selectCause(door){
    if(door=='open')
    {this.openTest=true
    this.scrol()}
    if(door=='close')
    this.openTest=false
  }

  scrol(){
    window.scrollTo(0,document.getElementById("data").scrollHeight);
    
  }

  blurEcart(){
    console.log("nice");
    

  }

}


